export * from "./HeroOfferView";
import HeroOfferView from "./HeroOfferView";
export default HeroOfferView;
